/* eslint-disable no-plusplus */
export default function removerAcentuacao(str) {
  const acentos = `ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ`;
  const semAcento = `AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr`;
  let retorno = '';

  for (let i = 0; i < str.length; i++) {
    let troca = false;

    for (let a = 0; a < acentos.length; a++) {
      if (str.substr(i, 1) === acentos.substr(a, 1)) {
        retorno += semAcento.substr(a, 1);
        troca = true;
        break;
      }
    }

    if (troca === false) {
      retorno += str.substr(i, 1);
    }
  }
  return retorno;
}
